/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

type PropTypes = {
    total: number;
    interval: number;
};

export default class ProgressBar extends React.PureComponent<PropTypes> {
    render() {
        const { total, interval } = this.props;
        let percentage = (interval / total) * 100;
        percentage = percentage > 100 ? 100 : percentage;
        return (
            <div className="rec-ratview-progress-bar">
                <div
                    className="rec-progress-bar-filler"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        );
    }
}
